import {create} from 'zustand';
import createSearchSlice from '@/services/store/search/searchSlice';

const useStore = create((...a) => ({
    ...createSearchSlice(...a),
}));

export default useStore;